import styled, { css } from 'styled-components';
import { imageBlurredFadeIn } from '@/components/image/imageLoadedFadeIn.styles';
import { imagePulse } from '@/components/image/imagePulse.styles';

export const CoverSection = styled.section`
  ${({ theme, ...props }) => {
    return css`
      //--banner-internal-height: 40vh;
      --banner-internal-height: 35rem;
      @media screen and (max-width: ${theme.breakpoint.sm}) {
        --banner-internal-height: 40vh;
      }
      position: relative;
      min-height: var(--banner-internal-height);

      // Makes the Breadcrumb within the cover banner
      margin-bottom: -3rem;
      overflow: hidden; // added after adding the image blur effect
    `;
  }};
`;

export const CoverlWrapper = styled.div`
  ${({ theme, ...props }) => {
    return css`
      > div {
        min-width: 100vw;
      }

      img {
        object-fit: cover;
        object-position: center;

        // Blur Effect
        ${imageBlurredFadeIn};
        &.img-loaded {
          opacity: 1 !important;
        }
      }
      // Pulse Effect
      ${imagePulse};

      // Builds an Overlay
      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        // Adds the background overlay
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.39) 0%, rgba(19, 19, 19, 0) 32.72%),
          linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4)), ${theme.color.primary_500};
        opacity: 0.3;
      }
    `;
  }};
`;
